import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expiration"]

  connect() {
    var hash = window.location.hash.substring(1)
    // Only switch tabs based on hash, otherwise let Bootstrap handle normal tab behavior
    if(hash == "tunnel_operator"){
      // Use Bootstrap's tab method to properly activate the tab
      $("#tunnel_operator-tab a[data-toggle=\"tab\"]").tab("show")
    } else if(hash == "country_code"){
      $("#country_code-tab a[data-toggle=\"tab\"]").tab("show")
    } else if(hash == ""){
      // No hash, ensure default tab is active
      $("#country_code-tab a[data-toggle=\"tab\"]").tab("show")
    }
  }
}
